export default {
  rpa: {
    metadata: {
      title: 'Automatiza Tareas Repetitivas con RPA: soluciones eficientes para tu empresa',
      desc: 'Descubre cómo la RPA puede transformar tu empresa, optimizando procesos y aumentando la productividad de tu equipo. Habla con nuestros especialistas y conoce los beneficios.',
    },
    hero: {
      title: '<span class="font-black">Transforma Tus Procesos</span> Repetitivos con Automatización Inteligente',
    },
    monthlyPlans: {
      title: '<span class="font-black">¡Planes mensuales</span> para que tengas lo mejor del RPA!',
      desc: '<span class="font-black">La Robotic Process Automation (RPA)</span>, que en español significa Automatización Robótica de Procesos, es una solución que automatiza actividades, reduce los costos de tu empresa, permite que tu equipo se enfoque en actividades realmente estratégicas y te ofrece la posibilidad de contratar un servicio mensual. ¡Te lo vamos a explicar mejor!',
    },
    whyChooseRpa: {
      title: '¿Por qué escoger la solución RPA?',
      cards: [
        {
          title: 'Mayor Eficiencia Operacional:',
          text: 'Automatiza tareas repetitivas y da libertad a tu equipo para realizar actividades más estratégicas, que producen valor real para tu empresa.',
        },
        {
          title: 'Seguridad y Compliance:',
          text: 'Gestiona el control de tareas de manera unificada y dinámica, con total seguridad y confiabilidad.',
        },
        {
          title: 'Reducción de Errores y Fallas:',
          text: 'Robots ejecutando tareas 24/7 con un alto nivel de excelencia y asertividad.',
        },
        {
          title: 'Reducción de Costos:',
          text: 'Reduce tiempo y costos operacionales con una fuerza de trabajo eficiente.',
        },
        {
          title: 'Retorno de la Inversión:',
          text: 'ROI alcanzado a corto plazo con automatizaciones que agregan valor a la operación.',
        },
        {
          title: 'Mejora la Experiencia del Cliente:',
          text: 'Fideliza a tus clientes resolviendo sus problemas, solicitudes y dudas más ágilmente.',
        },
      ],
    },
    featuresOurSolution: {
      title: 'Facilidades de Nuestra Solución',
      list: [
        {
          title: 'Modelo de Actuación SAAS:',
          text: 'Con este modelo, tu empresa no necesita instalar, mantener y actualizar hardwares o softwares. El acceso es simple, basta hacer una conexión por Internet.',
        },
        {
          title: 'Desarrollo de Bajo Costo:',
          text: 'No hay problema si tu empresa no tiene un equipo de TI. Nuestro equipo de especialistas hace todo el desarrollo y te da apoyo para la implantación de la plataforma.',
        },
        {
          title: 'Modelo de Contratación:',
          text: 'Adquieres el servicio pagando mensualidades. Es decir, escoges cuándo quieres utilizar el servicio.',
        },
        {
          title: 'Adaptable para Empresas de Todos los Tamaños:',
          text: 'No importa el tamaño de tu empresa, esta solución atiende eficientemente todos los tipos de empresa.',
        },
        {
          title: 'No Hay Necesidad de Licencias o Instalaciones:',
          text: 'El servicio se puede contratar solo cuando lo quieras utilizar.',
        },
      ],
      button: '¡Quiero conocer el RPA!',
    },
    rpaImplementation: {
      title: 'Con Nuestra Implantación del RPA Tienes:',
      button: '¡Transforma tu rutina con RPA!',
      cards: [
        {
          icon: 'Icon732',
          title: 'Integración',
          list: [
            'Integración con múltiples herramientas, aplicaciones, sitios web, Inteligencia Artificial y Machine Learning, y cualquier documento digital.',
            'Automatización de cualquier trabajo, a partir de la integración nativa con más de 500 aplicaciones.',
            'Posibilita la extracción de datos de 3.000 tipos de documentos en más de 80 idiomas con tecnologías de OCR.',
          ],
        },
        {
          icon: 'Icon730',
          title: 'Estrategia',
          list: [
            'Altamente escalable.',
            'Adquisición como servicio y pago mensual por uso.',
            'Adaptable a todos los tamaños de empresas.',
            'Da libertad a los empleados para realizar tareas más estratégicas.',
            'Apoyo continuo incluido en la mensualidad.',
          ],
        },
        {
          icon: 'Icon728',
          title: 'Seguridad',
          list: [
            'Adhiere a la seguridad de la información y LGPD;',
            'Evolución de la conformidad y de la reducción de riesgos y fraudes.',
          ],
        },
      ],
    },
    applicable: {
      title: '¿Dónde se Puede Aplicar el RPA?',
      cards: [
        {
          icon: 'icon710',
          title: 'Finanzas',
          list: [
            'Conciliación de Cuentas para Pagar/Cobranza;',
            'Conciliación Bancaria;',
            'Emisión de Recibos de Pago.',
          ],
        },
        {
          icon: 'icon712',
          title: 'Administrativo',
          list: ['Emisión de Facturas;', 'Captura de Facturas;', 'Conciliación Bancaria.'],
        },
        {
          icon: 'icon723',
          title: 'Salud',
          list: [
            'Actualización de Seguros de Salud en los portales;',
            'Emisión de Recibos de Pago e Informes para los clientes;',
            'Control de Glosa.',
          ],
        },
        {
          icon: 'icon717',
          title: 'Industria',
          list: ['Registro de Pedidos;', 'Emisión de registro de salida;', 'Busca de Licitaciones;'],
        },
        {
          icon: 'icon714',
          title: 'Logística',
          list: [
            'Cálculo de la DRE;',
            'Producción de Informaciones de Gestión;',
            'Seguimiento y Recolección de Entregas.',
          ],
        },
        {
          icon: 'icon721',
          title: 'Atención',
          list: [
            'Búsqueda de informaciones de Clientes;',
            'Control de Leads para atención;',
            'Control de Eficiencia en la atención.',
          ],
        },
        {
          icon: 'icon725',
          title: 'Jurídico',
          list: ['Baja de Procesos;', 'Baja de Siniestros;', 'Rellenado de Contratos.'],
        },
        {
          icon: 'icon719',
          title: 'Compras',
          list: ['Registro de Pedidos;', 'Búsqueda de Clientes;', 'Pesquisa de precios.'],
        },
      ],
    },
    counterPartnership: {
      title: '¡Cuenta con <br><span class="font-black">Nosotros!</span>',
      list: [
        `• <span class="font-black">Equipo de especialistas en RPA</span> y en otros servicios de tecnología;`,
        `• <span class="font-black">Más de 20 años de experiencia</span> en el mercado de tecnología;`,
        `• Creación, mantenimiento y apoyo para <span class="font-black">los robots hechos exclusivamente para ti</span>;`,
        `• <span class="font-black">Costos accesibles</span> y adaptados a tu empresa;`,
        `• <span class="font-black">Contratos mensuales</span>, optimizando costos;`,
        `• Capas adicionales de <span class="font-black">seguridad</span>.`,
      ],
    },
    talkToUs: {
      title: 'Estamos preparados para atender tus necesidades.',
      button: '¡Descubre más sobre RPA!',
    },
  },
}
